import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "grid-content ep-bg-purple" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "tab-title" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "功能暂未实现", -1)


import { defineComponent } from 'vue'
import ViewRender from '../components/ViewRender.vue'
import EditMenuPage from './administor/EditMenuPage.vue'
import EditPagePage from './administor/EditPagePage.vue'
import EditMenuPrivilegePage from './administor/EditMenuPrivilegePage.vue'
import EditUserProfilePage from './EditUserProfilePage.vue'
import ChangePasswordPage from './ChangePasswordPage.vue'
import { isEmptyString, getI18n } from '../utils'

import store from '../store'
// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'HomePageTabs'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const removeTab = (targetName:string) => {
  store.dispatch('removeTab', targetName)
}
const onClick = (pane:object, ev:object) => {
  store.dispatch('tabClick', { pane: pane, ev: ev })
}

return (_ctx: any,_cache: any) => {
  const _component_Expand = _resolveComponent("Expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      gutter: 20,
      justify: "center",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 1,
          align: "left"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(store).state.leftIsCollapse,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.leftIsCollapse) = $event)),
              style: {"margin-bottom":"0px"}
            }, {
              default: _withCtx(() => [
                (_unref(store).state.leftIsCollapse==true)
                  ? (_openBlock(), _createBlock(_component_el_radio_button, {
                      key: 0,
                      label: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Expand)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(store).state.leftIsCollapse==false)
                  ? (_openBlock(), _createBlock(_component_el_radio_button, {
                      key: 1,
                      label: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Fold)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 23,
          type: "flex",
          align: "left"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_unref(store).state.showPath), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider, { class: "home-page-divider" }),
    _createVNode(_component_el_tabs, {
      modelValue: _unref(store).state.editableTabsValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).state.editableTabsValue) = $event)),
      type: "card",
      class: "demo-tabs",
      onTabRemove: removeTab,
      onTabClick: onClick
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.editableTabs, (item) => {
          return (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            label: _unref(getI18n)(item.title),
            name: item.name,
            closable: item.closable
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_2,
                _createElementVNode("div", null, [
                  (_unref(isEmptyString)(item.bindPage))
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.data.children, (subItem) => {
                        return (_openBlock(), _createBlock(ViewRender, {
                          tabName: item.name,
                          item: subItem,
                          key: subItem.index
                        }, null, 8, ["tabName", "item"]))
                      }), 128))
                    : (item.bindPage === 'EditMenuPage')
                      ? (_openBlock(), _createBlock(EditMenuPage, {
                          key: 1,
                          item: item
                        }, null, 8, ["item"]))
                      : (item.bindPage === 'EditPagePage')
                        ? (_openBlock(), _createBlock(EditPagePage, {
                            key: 2,
                            tabName: item.name,
                            item: item
                          }, null, 8, ["tabName", "item"]))
                        : (item.bindPage === 'EditMenuPrivilegePage')
                          ? (_openBlock(), _createBlock(EditMenuPrivilegePage, {
                              key: 3,
                              tabName: item.name,
                              item: item
                            }, null, 8, ["tabName", "item"]))
                          : (item.bindPage === 'EditUserProfilePage')
                            ? (_openBlock(), _createBlock(EditUserProfilePage, {
                                key: 4,
                                item: item
                              }, null, 8, ["item"]))
                            : (item.bindPage === 'ChangePasswordPage')
                              ? (_openBlock(), _createBlock(ChangePasswordPage, {
                                  key: 5,
                                  item: item
                                }, null, 8, ["item"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _hoisted_3,
                                  _hoisted_4
                                ], 64))
                ])
              ])
            ]),
            _: 2
          }, 1032, ["label", "name", "closable"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})